<template>

    <div id="content" role="main">

      <div class="row mt-5">

        <div class="col-md-12">
          <div class="content_title">
            <h1>{{ $t("message.lieferscheine_h1") }}</h1>
          </div>
        </div>

      </div>
      <div class="row mt-5">

        <div class="col-md-12">

          <div id="filter" class="row pb-2">

            <div class="col-md-3" v-if="anySelected">
              <b-button size="sm" variant="primary" @click="downloadSelected">
                <b-icon-download></b-icon-download>&nbsp;{{ $t('message.lieferscheine_downloadpdfs') }}
              </b-button>
            </div>
            <div class="col-md-8" :class="anySelected ? 'col-md-8' : 'col-md-11'">

              <b-input-group size="sm">
                <b-form-input v-model="keyword"
                              type="search"
                              id="filterInput"
                              :placeholder="$t('message.positionen_filter')"
                />
                <b-input-group-append>
                  <b-button :disabled="!keyword" @click="keyword = ''"><b-icon-x></b-icon-x></b-button>
                </b-input-group-append>
              </b-input-group>

            </div>
            <div class="col-md-1 text-right">

              <b-form-group horizontal label="" class="">
                <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
              </b-form-group>

            </div>

          </div>
          <div id="lieferscheinTable">

            <div class="card-box table-responsive">
              <b-table small
                       hover
                       :items="items"
                       :fields="fields"
                       :current-page="currentPage"
                       :per-page="perPage"
                       :keyword="keyword">

                <template v-slot:head(selected)>
                  <b-form-checkbox :indeterminate="someVisibleSelected"
                                   :checked="allVisibleSelected"
                                   @change="toggleSelectAll($event)"
                                   aria-label="Select all">
                  </b-form-checkbox>
                </template>

                <template v-slot:cell(selected)="data">
                  <b-form-checkbox :checked="isSelected(data.item)"
                                   @change="toggleSelect(data.item, $event)"
                                   aria-label="Select row">
                  </b-form-checkbox>
                </template>

                <template v-slot:cell(datum)="data">
                  {{ formatDatum(data.item.datum) }}
                </template>

                <template v-slot:cell(text)="data">
                  <a :href="data.item.url" target="_blank">
                      <b-icon-box-arrow-in-up-right></b-icon-box-arrow-in-up-right> {{ $t("message.lieferscheine_pdf") }}
                  </a>
                </template>

              </b-table>
            </div>

            <b-row>
              <b-col md="12" class="my-1">
                <b-pagination v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                              size="sm"
                              class="my-0"
                />
              </b-col>
            </b-row>

          </div>

        </div>

      </div>

    </div>

</template>

<script>

  import axios from 'axios'
  axios.defaults.withCredentials = true

  export default {
    name: 'Lieferscheine',
    data () {
      return {

        sortBy: 'datum',
        sortDesc: true,
        /** Filter Query String */
        keyword: '',
        fields: [
          {
            label: '',
            key: 'selected',
            sortable: false,
            thStyle: { width: '30px' },
          },
          {
            label: this.$t("message.printMaengel_datum"),
            key: 'datum',
            sortable: true,
          },
          {
            label: this.$t("message.lieferscheine_kw"),
            key: 'kw',
            sortable: true,
          },
          {
            label: this.$t("message.printErgebnisliste_auftrag_nr"),
            key: 'scnummer',
            sortable: true,
          },
          {
            label: this.$t("message.lieferscheine_thema"),
            key: 'thema',
            sortable: true,
          },
          {
            label: '',
            key: 'text',
            sortable: false,
            class: 'text-right',
          }
        ],
        lieferscheine: null,
        //totalRows: null,
        currentPage: null,
        /** Anzahl der Positionen die in der Tabelle angezeigt werden sollen */
        pageOptions: [ 5, 10, 15, 20, 50, 100 ],
        /** ausgewählter Wert aus den pageOptions */
        perPage: 20,
        /** Ausgewählte Lieferscheine (URLs) */
        selectedUrls: [],

      }
    },
    computed: {

      // Gefilterte Items für die Tabelle
      items: function () {

        if (this.lieferscheine) {

          var lowercase = this.keyword ? this.keyword.toLowerCase() : null;

          var selectedRows = lowercase
              ? this.lieferscheine.filter(item =>

                  (item.datum && item.datum.toLowerCase().includes(lowercase)) ||
                  (item.kw && item.kw.toLowerCase().includes(lowercase)) ||
                  (item.scnummer && item.scnummer.toLowerCase().includes(lowercase)) ||
                  (item.thema && item.thema.includes(lowercase)) ||
                  (item.text && item.text.toLowerCase().includes(lowercase))

              ) : this.lieferscheine

          return selectedRows

        }
        return null
      },
      totalRows: function () {
        return this.items ? this.items.length : 0
      },
      anySelected: function () {
        return this.selectedUrls && this.selectedUrls.length > 0
      },
      allVisibleSelected: function () {
        const items = this.items || []
        if (items.length === 0) return false
        return items.every(i => this.selectedUrls.includes(i.url))
      },
      someVisibleSelected: function () {
        const items = this.items || []
        if (items.length === 0) return false
        const count = items.filter(i => this.selectedUrls.includes(i.url)).length
        return count > 0 && count < items.length
      }
    },
    created () {
      this.init()
    },
    methods: {

      isSelected: function(item) {
        if (!item || !item.url) return false
        return this.selectedUrls.includes(item.url)
      },
      toggleSelect: function(item, checked) {
        if (!item || !item.url) return
        const url = item.url
        const exists = this.selectedUrls.includes(url)
        if (checked && !exists) {
          this.selectedUrls = this.selectedUrls.concat([url])
        } else if (!checked && exists) {
          this.selectedUrls = this.selectedUrls.filter(u => u !== url)
        }
      },
      toggleSelectAll: function(checked) {
        const items = this.items || []
        if (checked) {
          const urlsToAdd = items.map(i => i.url).filter(url => !this.selectedUrls.includes(url))
          this.selectedUrls = this.selectedUrls.concat(urlsToAdd)
        } else {
          const visibleUrls = new Set(items.map(i => i.url))
          this.selectedUrls = this.selectedUrls.filter(u => !visibleUrls.has(u))
        }
      },
      /**
       * ausgewählte PDFs zusammenzippen und herunterladen
       */
      downloadSelected: function() {

        this.showSpinner()
        const urls = this.selectedUrls.slice()
        if (urls.length === 0) return

        // urls an Server senden, dort zippen und zip anzeigen
        const that   = this
        const url    = process.env.VUE_APP_SERVER_URL + '/report/downloadLieferscheine'
        const params = {
          urls: urls,
          customer: this.$store.getters.customer,
        }
        axios({
          method: 'POST',
          url: url,
          withCredentials: true,
          data: params,
          headers: {
            'Content-Type': 'application/json',
          }
        }).then(response => {

          if (response.data && response.data.url) {
            window.open(response.data.url, '_blank')
          } else {
            that.$bvToast.toast(that.$t('message.lieferscheine_download_error'), {
              title: that.$t('message.lieferscheine_download_error'),
              variant: 'danger',
              solid: true,
            })
          }
          that.hideSpinner()

        }).catch(error => {
          console.log(error)
          that.hideSpinner()
          that.$bvToast.toast(that.$t('message.lieferscheine_download_error'), {
            title: that.$t('message.lieferscheine_download_error'),
            variant: 'danger',
            solid: true,
          })
        })

      },

      formatDatum: function (datum) {
        if (!datum || datum.length !== 8) return datum
        return datum.substring(6, 8) + '.' + datum.substring(4, 6) + '.' + datum.substring(0, 4)
      },

      init: function() {

        // Umami Tracking aufrufen
        this.doTracking(this.$route.name)

        this.showSpinner()
        var that    = this
        var url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getLieferscheine'
        var customer = this.$store.getters.customer
        var params   = {
          customer: JSON.stringify(customer)
        };
        axios({
          method: 'GET',
          params: params,
          url: url
        }).then(function (response) {

          that.lieferscheine = response.data
          that.currentPage = 1 // Pagination auf 1 Seite setzen
          that.hideSpinner()

        }).catch(error => {
          console.log(error)
          that.hideSpinner()
        })

      }

    }

  }

</script>
<style scoped>
.custom-control.custom-checkbox {
  top: -18px
}
</style>
